import * as swcHelpers from '@swc/helpers';
import { toBaseLineItem } from './base-line-item.js';

const toSolutionOrderLineItem = (lineItem, intl, options = {})=>{
    return swcHelpers.objectSpread({}, toBaseLineItem(lineItem, intl, options), {
        type: 'SOLUTION'
    });
};

export { toSolutionOrderLineItem };
//# sourceMappingURL=solution-line-item.js.map
